<template>
  <el-cascader
      v-model="selectedValue"
      :options="addressOptions"
      :props="cascaderProps"
      clearable
      filterable
      placeholder="请选择省市区"
      @change="handleChange"
      :style="{ width: '100%' }"
  />
</template>

<script>
import rawData from "../utils/areaText.json"; // 原来的省市区街道 JSON

export default {
  props: {
    value: Array, // 选中的省市区
  },
  data() {
    return {
      selectedValue: this.value || [], // 绑定选中的值
      addressOptions: [], // 存储省市区数据
      cascaderProps: {
        label: "label",
        value: "value",
        children: "children",
        checkStrictly: false,
      },
    };
  },
  watch: {
    value(newVal) {
      this.selectedValue = newVal;
    },
    selectedValue(newVal) {
      this.$emit("input", newVal);
    },
  },
  created() {
    this.loadAddressData();
  },
  methods: {
    loadAddressData() {
      this.addressOptions = this.convertToCascaderFormat(rawData);
    },
    // 递归转换 JSON 为 el-cascader 格式，只保留省市区，不含街道
    convertToCascaderFormat(data) {
      return Object.keys(data).map((province) => {
        const cities = data[province];
        return {
          label: province,
          value: province,
          children: Object.keys(cities).map((city) => {
            const districtsOrStreets = cities[city];

            // districtsOrStreets 可能是数组（街道）或对象（区）
            if (Array.isArray(districtsOrStreets)) {
              // 直接把街道忽略，只返回 city 下一级为空（也可以为空数组）
              return {
                label: city,
                value: city,
                children: districtsOrStreets.length ? districtsOrStreets.map(district => ({
                  label: district,
                  value: district
                })) : []
              };
            }

            if (typeof districtsOrStreets === "object") {
              return {
                label: city,
                value: city,
                children: Object.keys(districtsOrStreets).map(district => ({
                  label: district,
                  value: district
                }))
              };
            }

            return {
              label: city,
              value: city
            };
          }),
        };
      });
    },
    handleChange(value) {
      this.$emit("input", value); // 触发 v-model 更新
    },
  },
};
</script>



// WEBPACK FOOTER //
// cascader.vue?58e510cb